import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=6c87d14d&scoped=true&"
import script from "./mobile.vue?vue&type=script&lang=js&"
export * from "./mobile.vue?vue&type=script&lang=js&"
import style0 from "./mobile.vue?vue&type=style&index=0&id=6c87d14d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87d14d",
  null
  
)

export default component.exports